var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKorea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 141 260",
    enableBackground: "new 0 0 141 260",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.778,132.515l-3.093,20.682l-10.123,17.033l-27.017,4.436l-3.522,11.075l-16.598-7.683l-8.577,1.909l-5.465,10.395 l-11.496-1.045l4.639,8.263l-7.659,7.007l-12.153-8.384l-4.905,8.819l-7.267-1.513l-8.003,1.416l-9.47-10.872l5.799-9.664 l-1.57-20.247l6.62-15.221l12.394-22.59l-4.784,2.199l-5.944-10.824l1.546-4.156l-4.107-14.207L9.18,94.776l5.702-15.245 l13.651,0.749l9.543,4.494l0.864-1.619L26.938,72.041l2.271-10.413l-4.301-8.48l-2.561-10.051l6.04-0.773l3.141-9.906l8.094-11.211 l7.441-4.421l22.856-0.483l10.945,1.136l8.794-7.176l1.505-7.627l2.24-0.635l10.075,23.363l16.623,22.663l10.389,19.256 l5.557,24.765l-1.86,7.562l0.749,10.148l-0.217,20.005L138.778,132.515z M8.141,245.194l-5.919,9.326l4.591,3.479l22.759-4.808 l1.401-3.02l-3.117-9.326L8.141,245.194z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKorea);
export default __webpack_public_path__ + "static/media/korea.8792c4dc8d301b8b1eb3b2ea0cf6c017.svg";
export { ForwardRef as ReactComponent };